export default "__VITE_ASSET__DlmHuafK__"